import { useEffect, useState } from "react";
import { Mail } from "lucide-react";

// Fixed "jump to contact" shortcut. Hidden while the contact section is on
// screen (it would only cover the form), so it never floats over what it
// points to.
const FloatingHelp = () => {
  const [atContact, setAtContact] = useState(false);

  useEffect(() => {
    const el = document.getElementById("contact");
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(([e]) => setAtContact(e.isIntersecting), { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  if (atContact) return null;

  return (
    <aside aria-label="Quick contact">
    <a
      href="#contact"
      className="fixed bottom-4 right-3 md:bottom-[24px] md:right-[24px] z-50 flex h-11 w-11 md:h-[56px] md:w-[56px] items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg transition-shadow hover:shadow-xl focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-focus-ring"
      aria-label="Contact us for help"
    >
      <Mail size={22} aria-hidden="true" />
    </a>
    </aside>
  );
};

export default FloatingHelp;
